import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getVariationTemplateLink } from 'utils/appRoutes';
import { MessageMedium } from 'modules/graphql';
import { isExperimentInMultiArmedBanditMode } from 'modules/experiments/ducks/selectors';
import { Tooltip } from 'ui/tooltip';
import { ControlBadge, WinnerTrophyBadge, WinningTrophyBadge } from '../badges';
import {
  PreviewImg,
  StyledLinkOption,
  StyledNameLink,
  StyledTooltipContent,
  VariationContent,
  VariationSubtitle,
  VariationThumbnail,
  VariationTitle,
  VariationWrapper,
} from './Styled';
import { MediumIcon } from '../icons';
import { TextNoWrap } from '../variantTable/cells/Styled';

type VariationDetailsProps = {
  id: number;
  name: string;
  subTitle: string;
  templateThumbnailUrl: string;
  messageMedium: MessageMedium;
  control: boolean;
  winner: boolean;
};

export const VariantDetails = ({
  id,
  name,
  subTitle,
  templateThumbnailUrl,
  messageMedium,
  control,
  winner,
}: VariationDetailsProps) => {
  const isExperimentInMABMode = useSelector(isExperimentInMultiArmedBanditMode);
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const spanElement = spanRef.current;
    if (spanElement) {
      setIsTruncated(spanElement.offsetHeight < spanElement.scrollHeight);
    }
  }, []);

  return (
    <VariationWrapper>
      <StyledLinkOption href={getVariationTemplateLink(id)}>
        <VariationThumbnail isThumbnailAvailable={!!templateThumbnailUrl}>
          {templateThumbnailUrl ? (
            <PreviewImg src={templateThumbnailUrl} />
          ) : (
            <MediumIcon messageMedium={messageMedium} />
          )}
        </VariationThumbnail>
      </StyledLinkOption>

      <VariationContent>
        <VariationTitle>
          <StyledNameLink inTable href={getVariationTemplateLink(id)}>
            <Tooltip
              isEnabled={isTruncated}
              tooltipContent={name}
              ContentComponent={StyledTooltipContent}
            >
              <span ref={spanRef}>{name}</span>
            </Tooltip>
          </StyledNameLink>
        </VariationTitle>
        <VariationSubtitle>
          <TextNoWrap>{subTitle}</TextNoWrap>
          {control && <ControlBadge />}
          {isExperimentInMABMode && winner && <WinningTrophyBadge />}
          {!isExperimentInMABMode && winner && <WinnerTrophyBadge />}
        </VariationSubtitle>
      </VariationContent>
    </VariationWrapper>
  );
};
